<template>
  <b-modal :title="`Edit Events`" size="md" v-model="visible" @ok="save" @cancel="hide" ok-title="Save" :ok-disabled="!canSave || saving">
    <b-row>
      <b-col cols="12">
        {{ attributes }}
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    canSave () {
      if (this.schedule.name) {
        return true
      }
      return false
    },
    ...mapGetters({
      account: 'global/account'
    }),
  },
  data () {
    return {
      visible: false,
      saving: false,
      attributes: [],
      schedule: {
        name: null,
      }
    }
  },
  methods: {
    async save () {
      this.saving = true
      // this.schedule.accountId = this.account.id

      // const { data } = await this.$axios.post(`/v1/schedules`, this.schedule)
      // await this.$store.dispatch('account/getSchedules')
      this.saving = false
      // this.$emit('add', data)
    },
    show () {
      this.visible = true
    },
    hide () {
      this.visible = false
    },
  },
  created () {
    // this.getDeviceTypes()
  },
  mounted () {
    this.$bus.$on('modal:editEvents', (attributes) => {
      this.attributes = attributes
      this.show();
    })
  },
  beforeDestroy () {
    this.$bus.$off('modal:editEvents')
  }
}
</script>
